import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class RadioButtonField extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    fieldValue: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired,
    fieldOnlyBoolean: PropTypes.bool,
    readOnly: PropTypes.bool,
    checked: PropTypes.bool.isRequired
  }

  render() {
    return (
      <div className="group">
        <div className="input-wrapper-checkbox">
          {!this.props.fieldOnlyBoolean ? (
            <label className="header" htmlFor={this.props.fieldName}>
              {this.props.name}
            </label>
          ) : null}
          <input
            name={this.props.fieldName}
            type="radio"
            checked={this.props.checked || false}
            onChange={this.handleChange}
            disabled={this.props.readOnly}
          />
        </div>
      </div>
    )
  }

  handleChange = () => {
    this.props.onChange(this.props.fieldValue, this.props.fieldName)
  }
}
